import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import { EnvioDocumentos } from '@/features/enviar-documentos/components'
import type { TPessoaDocumento } from '@/features/proposta/interfaces/proposta.type'
import { Page } from '@/layouts/page'
import { recuperarDocumentosPessoaDaPropostaQuery } from '@/pages/envio-documentos-proposta/api'
import { useEnviarDocumentosProposta } from '@/pages/envio-documentos-proposta/api/use-enviar-documentos-proposta'
import { listaDocumentosPessoaFisica, listaDocumentosPessoaJuridica } from '@/shared/entities'
import { useTypedLocation } from '@/shared/hooks/use-typed-location'

export const EnvioDocumentosPropostaPage = () => {
  const { t } = useTranslation('proposta')
  const params = useParams()
  const { state } = useTypedLocation<{ pessoa: TPessoaDocumento }>()
  const isPessoaFisica = state?.pessoa?.documento.includes('CPF')
  const tiposDocumentos = (isPessoaFisica ? listaDocumentosPessoaFisica : listaDocumentosPessoaJuridica).sort((a, b) =>
    a.label.localeCompare(b.label),
  )
  const { mutateAsync: enviarDocumentoMutation } = useEnviarDocumentosProposta({
    numero: params.numero!,
    pessoaId: state.pessoa.pessoaId,
  })

  return (
    <Page
      breadcrumb={[
        { label: t('pages.envio_documentos.breadcrumb.historico'), to: '/historico/propostas' },
        { label: t('pages.envio_documentos.breadcrumb.proposta_ativa'), to: `/proposta/${params.numero}` },
        { label: t('pages.envio_documentos.breadcrumb.documentos'), to: `/proposta/${params.numero}/documentos` },
        { label: t('pages.envio_documentos.breadcrumb.enviar_documentos') },
      ]}
      className="mx-auto max-w-4xl"
    >
      <Page.Main>
        <Page.Header>
          <Page.Title>{t('pages.envio_documentos.titulo')}</Page.Title>
          <Page.Description>{t('pages.envio_documentos.descricao')}</Page.Description>
        </Page.Header>
        <Page.Section>
          <EnvioDocumentos
            config={{
              pessoa: { tipo: 'proposta', ...state.pessoa },
              documentTypes: tiposDocumentos,
              backButtonText: t('pages.envio_documentos.lista_compradores'),
              enviarDocumentoMutation,
              recuperarDocumentosQuery: recuperarDocumentosPessoaDaPropostaQuery(params.numero!, state.pessoa.pessoaId),
            }}
          >
            <EnvioDocumentos.Header />
            <EnvioDocumentos.Form />
            <EnvioDocumentos.List />
          </EnvioDocumentos>
        </Page.Section>
      </Page.Main>
    </Page>
  )
}
